angular
  .module('contrast.factory.library', [])
  .factory('LibraryFactory', function ($http, $q, UserService) {
    var service = {
      getFiltersByType: function (type, filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'get',
            url: UserService.buildAPIUrl(
              '/libraries/filters/' + type + '/listing'
            ),
            params: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getLibraries: function (expandValue) {
        return $http.get(UserService.buildAPIUrl('/libraries'), {
          params: { expand: expandValue }
        })
      },
      getLibrariesScoreBreakdown: function () {
        return $http.get(UserService.buildAPIUrl('/libraries/breakdown/scores'))
      },
      getLibrariesOutOfDate: function () {
        return $http.get(
          UserService.buildAPIUrl('/libraries/breakdown/outofdate')
        )
      },
      getLibrariesByFilter: function (data) {
        var httpTimeout = $q.defer()
        var request = $http({
          method: 'get',
          url: UserService.buildAPIUrl('/libraries/filter'),
          params: data,
          timeout: httpTimeout.promise
        })
        var promise = request.then()
        promise._httpTimeout = httpTimeout
        return promise
      },
      getLibrariesStats: getLibrariesStats,
      getByLang: getByLang,
      updateLibraryPolicy: updateLibraryPolicy,
      getLibrariesPolicy: getLibrariesPolicy,
      getLibraryPolicy: getLibraryPolicy,
      getLibraryPolicyLicenses: getLibraryPolicyLicenses,
      getExportAllUrl: getExportAllUrl,
      deleteOrgLibraries: deleteOrgLibraries,
      deleteServerLibraries: deleteServerLibraries,
      deleteAppLibraries: deleteAppLibraries,
      sendToBugtracker: sendToBugtracker,
      sendByEmail: sendByEmail
    }

    function getLibrariesStats() {
      return $http.get(UserService.buildAPIUrl('/libraries/stats'))
    }

    function updateLibraryPolicy(form) {
      return $http.put(UserService.buildAPIUrl('/library/policy'), form)
    }

    function getLibrariesPolicy() {
      return $http.get(UserService.buildAPIUrl('/library/policy/libraries'))
    }

    function getLibraryPolicy() {
      return $http.get(UserService.buildAPIUrl('/library/policy'))
    }

    function getLibraryPolicyLicenses() {
      return $http.get(UserService.buildAPIUrl('/library/policy/licenses'))
    }

    var validLanguages = {
      java: true,
      dotnet: true,
      '.net': true,
      node: true,
      ruby: true,
      python: true,
      go: true,
      php: true
    }

    function getByLang(lang, hash, expandValue, appID, serverID) {
      if (!angular.isString(lang)) {
        throw new Error('Language must be a string')
      }
      lang = lang.toLowerCase()
      if (!validLanguages[lang]) {
        throw new Error('Invalid language specified')
      }
      var url = UserService.buildAPIUrl('/libraries/' + lang + '/' + hash)
      return $http.get(url, {
        params: {
          expand: expandValue,
          appID: appID,
          serverID: serverID
        }
      })
    }

    function getExportAllUrl() {
      return UserService.buildAPIUrl('/libraries/export')
    }

    function deleteOrgLibraries(libraryDeleteRequest) {
      return $http['delete'](UserService.buildAPIUrl('/libraries'), {
        data: libraryDeleteRequest,
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function deleteServerLibraries(serverId, libraryDeleteRequest) {
      return $http['delete'](
        UserService.buildAPIUrl('/servers/' + serverId + '/libraries'),
        {
          data: libraryDeleteRequest,
          headers: { 'Content-Type': 'application/json' }
        }
      )
    }

    function deleteAppLibraries(appId, libraryDeleteRequest) {
      return $http['delete'](
        UserService.buildAPIUrl('/applications/' + appId + '/libraries'),
        {
          data: libraryDeleteRequest,
          headers: { 'Content-Type': 'application/json' }
        }
      )
    }

    function sendToBugtracker(bugtrackerId, data) {
      return $http.post(
        UserService.buildAPIUrl('/libraries/bugtracker/' + bugtrackerId),
        data
      )
    }

    function sendByEmail(data) {
      return $http.post(UserService.buildAPIUrl('/libraries/share/email'), data)
    }

    return service
  })
